import { BSidebarItem } from '@barbanet/ui-kit/components'

const sidebarItems = [
	{
		id: 'shipper',
		label: 'shared.shipperCompany',
		icon: 'factory-02',
		children: [
			{
				id: 'companies',
				label: 'shared.companies',
				to: { name: 'ShipperCompaniesReport' }
			},
			{
				id: 'users',
				label: 'shared.users',
				to: { name: 'ShipperUsersReport' }
			},
			{
				id: 'ShipperLocationsReport',
				label: 'shared.locations',
				to: { name: 'ShipperLocationsReport' }
			}
		]
	}
] as BSidebarItem[]

export default sidebarItems
